/**
 * Get the display name for a chime file
 * @param url - The URL of the chime file
 * @param index - The index of the chime in the array
 * @param metadataFileName - Optional filename from metadata (used for the first chime)
 * @returns The display name for the chime
 */
export const getChimeDisplayName = (
  url: string,
  index: number,
  metadataFileName?: string,
): string => {
  if (metadataFileName && index === 0) {
    return metadataFileName;
  }

  try {
    const urlParts = url.split("/");
    const filename = urlParts[urlParts.length - 1];
    const decodedName = decodeURIComponent(filename.split("?")[0]);
    return decodedName.replace(/\.[^/.]+$/, "") || `Chime ${index + 1}`;
  } catch {
    return `Chime ${index + 1}`;
  }
};
